export const getCssVarInPx = (varName: string) => {
  const value = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();

  if (value.endsWith('rem')) {
    const rem = parseFloat(value);
    const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return rem * remInPx;
  }

  if (value.endsWith('px')) {
    return parseFloat(value);
  }

  return 0;
};
